import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import { ModalController, Platform, ToastController } from "@ionic/angular";
import { AnimationOptions } from "ngx-lottie";
import { Subscription } from "rxjs";
import { Clipboard } from "@capacitor/clipboard";

@Component({
  selector: "app-must-connect-network-info-modal",
  templateUrl: "./must-connect-network-info-modal.component.html",
  styleUrls: ["./must-connect-network-info-modal.component.scss"],
})
export class MustConnectNetworkInfoModalComponent implements OnInit, OnDestroy {
  @Input() storeWifiNetworkName: any;
  @Input() storeWifiNetworkPassword: any;
  @Input() currentUser: any;
  options: AnimationOptions = {
    path: "https://data.deliverymanager.gr/animations/wifi-animation-1.json",
  };

  public copyButtonDisabled = false;
  public failedToCopyText = false;

  private disableCopyButtonTimeout: any;
  private unsubscribeBackEvent: Subscription;

  constructor(
    private modalController: ModalController,
    private toastController: ToastController,
    private platform: Platform
  ) {}

  ngOnInit(): void {
    this.unsubscribeBackEvent = this.platform.backButton.subscribeWithPriority(
      300,
      () => {
        if (this.platform.is("android")) {
          this.closeModal();
        }
      }
    );
  }

  copyAffiliateNumber(text) {
    this.copyButtonDisabled = true;
    if (Capacitor.isNativePlatform()) {
      console.log("clipboard mobile");
      this.copyToClipboardMobile(text);
    } else {
      console.log("clipboard browser");
      this.copyToClipboardBrowser(text);
    }
  }

  copyToClipboardBrowser(text) {
    navigator.clipboard
      .writeText(text)
      .then(async () => {
        this.failedToCopyText = false;
        this.disableCopyButtonTimeout = setTimeout(() => {
          this.copyButtonDisabled = false;
        }, 1000);
      })
      .catch(async () => {
        this.failedToCopyText = true;
        this.copyButtonDisabled = false;
        const toast = await this.toastController.create({
          message: "Try again!",
          cssClass: "copied-to-clipboard",
          color: "primary",
          duration: 1000,
          position: "middle",
        });
        toast.present();
        toast.onDidDismiss().then(() => {
          this.failedToCopyText = false;
        });
        console.log("Failed to copy text.");
      });
  }

  copyToClipboardMobile(text) {
    Clipboard.write({ string: text })
      .then(async () => {
        this.failedToCopyText = false;
        this.disableCopyButtonTimeout = setTimeout(() => {
          this.copyButtonDisabled = false;
        }, 1000);
      })
      .catch(async () => {
        this.failedToCopyText = true;
        this.copyButtonDisabled = false;
        const toast = await this.toastController.create({
          message: "Try again!",
          cssClass: "copied-to-clipboard",
          color: "primary",
          duration: 1000,
          position: "middle",
        });
        toast.present();
        toast.onDidDismiss().then(() => {
          this.failedToCopyText = false;
        });
        console.log("Failed to copy text.");
      });
  }

  closeModal() {
    this.modalController.dismiss();
  }

  animationCreated(ev) {}

  ngOnDestroy(): void {
    this.unsubscribeBackEvent.unsubscribe();
  }
}
